// extracted by mini-css-extract-plugin
export var sliderRange = "_oi-2";
export var sliderRoot = "_oi-0";
export var sliderThumb = "_oi-3";
export var sliderTrack = "_oi-1";